






























import { Vue, Component, Watch } from "vue-property-decorator";
import ActivityNote from "@/components/Sidebar/Activity/ActivityNote.vue";
import Rep from "@/components/Sidebar/Rep/Rep.vue";
import {User} from "../../../models/user_schema";
import { StoreModule } from "@/store/types";
import { RepGetters, RepActions } from "@/store/modules/rep/types";
import { namespace } from "vuex-class";
import { ActivitySchema } from "@/models/activity_schema";
import moment from "moment";
import RepService from "@/services/rep_service";
import { Roles } from "@/models/roles";
import { UserGetters } from "@/store/modules/user/types";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import simplebar from 'simplebar-vue';

@Component({
  components: {
    Rep,
    ActivityNote,
    simplebar
  },
})
export default class SingleRep extends Vue {
  protected selectedRepId!: string;
  protected repService = new RepService();
  protected notes = [] as ActivitySchema[];
  protected Roles = Roles;
  @(namespace(StoreModule.Rep).Action(RepActions.FetchSingleRep))
  fetchSingleRep;
  @(namespace(StoreModule.Rep).Action(RepActions.SetSelectedRep))
  addActiveRep;
  @(namespace(StoreModule.Rep).Getter(RepGetters.GetSelected))
  selected;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.User).Getter(UserGetters.GetUser)) user;

 created() {
    this.selectedRepId = this.$route.params.id ? this.$route.params.id.trim() : 'me';
    if (this.role === Roles.SalesRep && this.selectedRepId !== this.user._id) {
      this.$router.replace({
        path: "/reps/" + 'me',
        query: { region: this.user.rep_info.sales_region },
      }).catch((err) => {});
    }
    this.getRep();
    this.fetchActivityNotes();
  }

  public goBackToRepList(): void {
    this.$router.push({
        path: "/",
        query: this.$route.query.region ? { region: this.$route.query.region } : {},
    });
    this.addActiveRep({});
  }

  @Watch("$route.params.id")
  protected onChange(): void {
    if (this.role !== Roles.SalesRep) {
      this.selectedRepId = this.$route.params.id.trim();
      this.getRep();
      this.fetchActivityNotes();
    }
  }

  public async getRep(): Promise<void> {
      try {
      await this.fetchSingleRep(this.selectedRepId);
      } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public updateNotes(id: string): void {
    this.notes = this.notes.filter((note) => {
      return note._id !== id;
    });
  }

  public async fetchActivityNotes(): Promise<void> {
    try {
      const res = await this.repService.getRepActivities(this.selectedRepId);
      this.notes = res;
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public update(updatedNotes: ActivitySchema[]): void {
    this.notes = updatedNotes;
  }

  public get rep(): User {
    return this.selected;
  }

  protected get activityUpdate(): string | false {
    let update;
    if (this.notes.length < 1) {
      update = false;
    } else {
      const now = moment();
      const then = moment(this.notes[0].contacted_at);
      const difference = now.diff(then, "days");
      if (difference === 0) {
        update = "Less than a day ago";
      } else {
        update = difference + " days ago";
      }
    }
    return update;
  }
}
